import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { MegaphoneIcon } from '@/components/ui/SvgIcon/Static/SvgIconComponents';
import { Head } from '@/components/ui/Typography/Heading/Head';
import { IconTextGroup } from '@/components/ui/Typography/IconText/IconTextGroup';
const spaces = {
    none: '',
    normal: 'p-20',
};
export const ProposalRequestCommentBox = (props) => {
    const { children, className = '', space = 'normal' } = props;
    return (_jsxs("div", Object.assign({ className: clsx('bg-gradient-to-l from-gradient-lite-blue-from to-gradient-lite-blue-to', 'rounded-md', 'overflow-hidden', className) }, { children: [_jsxs(IconTextGroup, Object.assign({ className: clsx('p-12', 'bg-gradient-to-l from-gradient-lite-blue-from to-gradient-lite-blue-to'), space: 'wide' }, { children: [_jsx(MegaphoneIcon, { size: 'lg' }), _jsx(Head, Object.assign({ color: 'white', size: 'xs' }, { children: "\u3054\u63D0\u6848\u3092\u5E0C\u671B\u3057\u307E\u3059" }))] })), _jsx("div", Object.assign({ className: clsx('bg-white', 'rounded-b-md', 'ml-1 mr-1 mb-1', spaces[space]) }, { children: children }))] })));
};
